import React from 'react';
import { DataTable } from '../../common';

/**
 * Wraps DataTable with panel-specific column configuration.
 */
const ResultsTable = ({ columns, data, emptyMessage }) => (
  <div className="mt-4">
    <DataTable columns={columns} data={data} emptyMessage={emptyMessage} />
  </div>
);

export default ResultsTable;
